const initPaymentFix = () => {
  const targetSelector = 'a[data-payment-link="true"]';
  document.addEventListener('click', (event) => {
    const link = event.target.closest(targetSelector);

    if (link) {
      event.preventDefault();
      const targetUrl = link.getAttribute('data-payment-link-url');

      if (targetUrl) {
        const cleanUrl = targetUrl.includes('#') ? targetUrl : `${targetUrl}#`;
        window.location.href = cleanUrl;
      }
    }
  }, true);

};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPaymentFix);
} else {
  initPaymentFix();
}